import { createContext, useContext, useEffect, useState } from "react";
import { apiRequest } from "./AdminAuthContext";

const EmployerAuthContext = createContext(null);

export function EmployerAuthProvider({ children }) {
  const [employer, setEmployer] = useState(null);
  const [ready, setReady] = useState(false);

  const refreshEmployer = async () => {
    try {
      setEmployer(await apiRequest("/employer-auth/me"));
    } catch {
      setEmployer(null);
    } finally {
      setReady(true);
    }
  };

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setReady(true);
      return;
    }
    refreshEmployer();
  }, []);
  return <EmployerAuthContext.Provider value={{ employer, setEmployer, ready, refreshEmployer }}>{children}</EmployerAuthContext.Provider>;
}

export function useEmployerAuth() {
  return useContext(EmployerAuthContext);
}